import React from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import InputMask from 'react-input-mask';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';
import { normalizeDate } from '../Utils/GlobalUtils';

import HeadlinePanel from '../Components/HeadlinePanel';
import Loading from '../Components/Loading';

import miniTable from '../styles/MiniTables.module.css';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as CheckIcon } from '../icons/check.svg';
import InputRegionSelector from '../Components/InputSpecialFields/InputRegionSelector';

export default function EditDebtor({ action }) {
    const { id } = useParams();
    const { openTimeModal } = useTimeModal();
    const navigate = useNavigate();
    
    const [formInfo, setFormInfo] = React.useState({
        id: '',
        name: '',
        entity_type: 'Физическое лицо',
        region_id: '',
        region_name: '',
        date_of_birth: '',
        place_of_birth: '',
        postal_address: '',
        TIN: '',
        TIN_file_id: '',
        SNILS: '',
        SNILS_file_id: '',
        OGRN: '',
        description: '',
    });

    const [loading, setLoading] = React.useState(true);
    const [status, setStatus] = React.useState(<a>Сохраните изменения</a>);

    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-full-info-debtor?id=${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((response) => {
                const newData = response.data;
                setFormInfo((prev) => {
                    const updated = { ...prev };
                    for (const key in newData) {
                        if (newData[key] !== null && newData[key] !== undefined) {
                            updated[key] = newData[key];
                        }
                    }
                    return updated;
                });
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.value;

        setStatus(<p>Сохраните изменения</p>);
    
        setFormInfo((prev) => ({ ...prev, [field]: value }));
    
        setErrorsForm((prevErrors) => {
          if (!prevErrors[field]) return prevErrors;
          const updatedErrors = { ...prevErrors };
          delete updatedErrors[field];
          return updatedErrors;
        });
    };
    
    const [errorsForm, setErrorsForm] = React.useState({});
    const validateForm = () => {
        const newErrors = {};

        if (!formInfo.name) {
            newErrors.name = 'Обязательное поле';
        }
        if (formInfo.name && (formInfo.name.length < 2 || formInfo.name.length > 150)) {
            newErrors.postal_address = 'Значение не может быть меньше 2 и более 150 символов';
        }
        if (!formInfo.entity_type) {
            newErrors.type = 'Обязательное поле';
        }
        if (!formInfo.region_id) {
            newErrors.region = 'Выберите регион';
        }
        if (formInfo.place_of_birth && (formInfo.place_of_birth.length < 2 || formInfo.place_of_birth.length > 100)) {
            newErrors.place_of_birth = 'Значение не может быть меньше 2 и более 100 символов';
        }
        if (formInfo.postal_address && (formInfo.postal_address.length < 2 || formInfo.postal_address.length > 150)) {
            newErrors.postal_address = 'Значение не может быть меньше 2 и более 150 символов';
        }
        if (formInfo.comment && (formInfo.comment.length < 2 || formInfo.comment.length > 200)) {
            newErrors.comment = 'Значение не может быть меньше 2 и более 200 символов';
        }

        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addNewDebtor = () => {
        const token = localStorage.getItem('token');

        axios.post('/api/add-new-debtor', {
            name: formInfo.name,
            entity_type: formInfo.entity_type,
            region_id: formInfo.region_id,
            date_of_birth: normalizeDate(formInfo.date_of_birth),
            place_of_birth: formInfo.place_of_birth,
            postal_address: formInfo.postal_address,
            TIN: formInfo.TIN,
            SNILS: formInfo.SNILS,
            OGRN: formInfo.OGRN,
            description: formInfo.description,
        },
        {
            headers: {
            Authorization: `Bearer ${token}`
            }
        })
        .then(() => {
            setStatus(<a>Данные сохранены</a>);
            openTimeModal('Должник добавлен', 'success');
            navigate('/registers');
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
            setStatus(<a className='mainLabelError'>Данные не сохранены</a>);
        });
    };

    const changeDebtor = () => {
        const token = localStorage.getItem('token');

        axios.put('/api/change-debtor', {
            id: formInfo.id,
            name: formInfo.name,
            entity_type: formInfo.entity_type,
            region_id: formInfo.region_id,
            date_of_birth: normalizeDate(formInfo.date_of_birth),
            place_of_birth: formInfo.place_of_birth,
            postal_address: formInfo.postal_address,
            TIN: formInfo.TIN,
            SNILS: formInfo.SNILS,
            OGRN: formInfo.OGRN,
            description: formInfo.description,
        },
        {
            headers: {
            Authorization: `Bearer ${token}`
            }
        })
        .then(() => {
            setStatus(<a>Данные сохранены</a>);
            openTimeModal('Данные изменены', 'success');
            navigate(`/debtor/${formInfo.id}`);
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
            setStatus(<a className='mainLabelError'>Данные не сохранены</a>);
        });
    };

    const handleSave = () => {
        if (validateForm()) {
            if (action=='add') {
                addNewDebtor();
            } 
            if (action=='change') {
                changeDebtor();
            }
        }
    };

    const pageLabels = {
        add: 'Добавление должника',
        change: 'Редактирование сведений о должнике',
    };

    return (
        <div className='mainContainer'>
            <HeadlinePanel 
                label={pageLabels[action] || 'Действия над сведениями о должнике'}
                type='Назад' 
            />
            <div className='containerInner'>
                <div className='pageWrapper'>
                    <div className='pageLimiter'>
                    <h3 className='formHeadline'>Основная информация</h3>
                    <div className='labelInputWrapper'>
                        <a className='label'>{formInfo.entity_type==='Физическое лицо' ? 'ФИО' : 'Наименование'}</a>
                        <div className='labelInputRight'>
                            <input 
                                type='text' 
                                value={formInfo.name} 
                                onChange={handleChange('name')} 
                                className={errorsForm.name ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='150' 
                                disabled={action=='change'} 
                            />
                            {errorsForm.name && <div className='errorUnderInput'>{errorsForm.name}</div>}
                        </div>
                    </div>

                    <div className='labelInputWrapper'>
                        <a className='label'>Категория должника</a>
                        <div className='labelInputRight'>
                            <div className='radioSwitchWrapper'>
                                <label className={`radioSwitchLabel ${formInfo.entity_type === 'Физическое лицо' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='Физическое лицо'
                                        checked={formInfo.entity_type === 'Физическое лицо'}
                                        onChange={handleChange('entity_type')}
                                    />
                                    <span>Физическое лицо</span>
                                </label>
                                <label className={`radioSwitchLabel ${formInfo.entity_type === 'Юридическое лицо' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='Юридическое лицо'
                                        checked={formInfo.entity_type === 'Юридическое лицо'}
                                        onChange={handleChange('entity_type')}
                                    />
                                    <span>Юридическое лицо</span>
                                </label>
                            </div>
                            {errorsForm.entity_type && <div className='errorUnderInput'>{errorsForm.entity_type}</div>}
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Регион банкротства</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <InputRegionSelector
                                    initialSearchTerm={formInfo.region_name}
                                    formInfo={formInfo}
                                    setFormInfo={setFormInfo}
                                    errorsForm={errorsForm}
                                    setErrorsForm={setErrorsForm}
                                />
                            </div>
                        </div>
                    </div>
                    {formInfo.entity_type==='Физическое лицо' &&
                    <>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата рождения</a>
                        <div className='labelInputRight'>
                            <input type='date' 
                            value={formInfo.date_of_birth?.split('T')[0]}
                            onChange={handleChange('date_of_birth')} 
                            placeholder='' 
                            minLength='' 
                            maxLength='' 
                            required />
                            {errorsForm.date_of_birth && <div className='errorUnderInput'>{errorsForm.date_of_birth}</div>}
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Место рождения</a>
                        <div className='labelInputRight'>
                            <input 
                            type='text' 
                            value={formInfo.place_of_birth} 
                            onChange={handleChange('place_of_birth')} 
                            className={errorsForm.place_of_birth ? 'inputError' : ''}
                            placeholder='Например, ГОРОД МОСКВА' 
                            minLength='' 
                            maxLength='100' 
                            required />
                            {errorsForm.place_of_birth && <div className='errorUnderInput'>{errorsForm.place_of_birth}</div>}
                        </div>
                    </div>
                    </>}

                    <div style={{height: '20px'}}></div>
                    
                    <h3 className='formHeadline'>Документы</h3>
                    <div className='labelInputWrapper'>
                        <a className='label'>Адрес</a>
                        <div className='labelInputRight'>
                            <input 
                            type='text' 
                            value={formInfo.postal_address} 
                            onChange={handleChange('postal_address')} 
                            className={errorsForm.postal_address ? 'inputError' : ''}
                            placeholder='Например, Россия, г.Санкт-Петербург, ул.Рубинштейна, 8' 
                            minLength='' 
                            maxLength='150' 
                            required />
                            {errorsForm.postal_address && <div className='errorUnderInput'>{errorsForm.postal_address}</div>}
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>{formInfo.entity_type==='Физическое лицо' ? 'ОГРНИП' : 'ОГРН'}</a>
                        <div className='labelInputRight'>
                            <input 
                            type='text' 
                            value={formInfo.OGRN} 
                            onChange={handleChange('OGRN')} 
                            className={errorsForm.OGRN ? 'inputError' : ''}
                            placeholder='' 
                            minLength='' 
                            maxLength='15' 
                            required />
                            {errorsForm.OGRN && <div className='errorUnderInput'>{errorsForm.OGRN}</div>}
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>ИНН</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <InputMask
                                mask="999999999999"
                                value={formInfo.TIN}
                                onChange={handleChange('TIN')}
                                maskChar={null}
                                >
                                {(inputProps) => (
                                    <input
                                    {...inputProps}
                                    type='text'
                                    placeholder=''
                                    className={errorsForm.TIN ? 'inputError' : ''}
                                    />
                                )}
                                </InputMask>
                                {errorsForm.TIN && <div className='errorUnderInput'>{errorsForm.TIN}</div>}
                            </div>
                        </div>
                    </div>
                    {formInfo.entity_type==='Физическое лицо' &&
                    <div className='labelInputWrapper'>
                        <a className='label'>СНИЛС</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <InputMask
                                mask="999-999-999 99"
                                value={formInfo.SNILS}
                                onChange={handleChange('SNILS')}
                                >
                                {(inputProps) => (
                                    <input
                                    {...inputProps}
                                    type='text'
                                    placeholder=''
                                    className={errorsForm.SNILS ? 'inputError' : ''}
                                    />
                                )}
                                </InputMask>
                                {errorsForm.SNILS && <div className='errorUnderInput'>{errorsForm.SNILS}</div>}
                            </div>
                        </div>
                    </div>}

                    <div style={{height: '20px'}}></div>

                    <h3 className='formHeadline'>Дополнительное</h3>

                    <div className='labelInputWrapper'>
                        <a className='label'>Примечание</a>
                        <div className='labelInputRight'>
                            <div>
                                <textarea 
                                    cols='10' 
                                    rows='10' 
                                    value={formInfo.description}  
                                    onChange={handleChange('description')}
                                    minLength='' 
                                    maxLength='900' 
                                    require=''
                                >
                                </textarea>
                                <p className='description'>{formInfo.description.length}/900</p>
                            </div>
                            {errorsForm.description && <div className='errorUnderInput'>{errorsForm.description}</div>}
                        </div>
                    </div>

                    <div className='panelFormConfirmation'>
                        <button 
                            type='button' 
                            className='button' 
                            onClick={handleSave}
                        >
                            {action=='add' && 'Добавить'}
                            {action=='change' && 'Сохранить'}
                        </button>
                        {status && <div>{status}</div>}
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
